function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import NotRepresentableException from '../algorithm/NotRepresentableException';
import Coordinate from './Coordinate';
import Double from '../../../../java/lang/Double';
import Orientation from '../algorithm/Orientation';
import Comparable from '../../../../java/lang/Comparable';
import RobustLineIntersector from '../algorithm/RobustLineIntersector';
import HCoordinate from '../algorithm/HCoordinate';
import Serializable from '../../../../java/io/Serializable';
import Distance from '../algorithm/Distance';
var LineSegment = /*#__PURE__*/function () {
  function LineSegment() {
    _classCallCheck(this, LineSegment);
    LineSegment.constructor_.apply(this, arguments);
  }
  return _createClass(LineSegment, [{
    key: "minX",
    value: function minX() {
      return Math.min(this.p0.x, this.p1.x);
    }
  }, {
    key: "orientationIndex",
    value: function orientationIndex() {
      if (arguments[0] instanceof LineSegment) {
        var seg = arguments[0];
        var orient0 = Orientation.index(this.p0, this.p1, seg.p0);
        var orient1 = Orientation.index(this.p0, this.p1, seg.p1);
        if (orient0 >= 0 && orient1 >= 0) return Math.max(orient0, orient1);
        if (orient0 <= 0 && orient1 <= 0) return Math.max(orient0, orient1);
        return 0;
      } else if (arguments[0] instanceof Coordinate) {
        var p = arguments[0];
        return Orientation.index(this.p0, this.p1, p);
      }
    }
  }, {
    key: "toGeometry",
    value: function toGeometry(geomFactory) {
      return geomFactory.createLineString([this.p0, this.p1]);
    }
  }, {
    key: "isVertical",
    value: function isVertical() {
      return this.p0.x === this.p1.x;
    }
  }, {
    key: "equals",
    value: function equals(o) {
      if (!(o instanceof LineSegment)) {
        return false;
      }
      var other = o;
      return this.p0.equals(other.p0) && this.p1.equals(other.p1);
    }
  }, {
    key: "intersection",
    value: function intersection(line) {
      var li = new RobustLineIntersector();
      li.computeIntersection(this.p0, this.p1, line.p0, line.p1);
      if (li.hasIntersection()) return li.getIntersection(0);
      return null;
    }
  }, {
    key: "project",
    value: function project() {
      if (arguments[0] instanceof Coordinate) {
        var p = arguments[0];
        if (p.equals(this.p0) || p.equals(this.p1)) return new Coordinate(p);
        var r = this.projectionFactor(p);
        var coord = new Coordinate();
        coord.x = this.p0.x + r * (this.p1.x - this.p0.x);
        coord.y = this.p0.y + r * (this.p1.y - this.p0.y);
        return coord;
      } else if (arguments[0] instanceof LineSegment) {
        var seg = arguments[0];
        var pf0 = this.projectionFactor(seg.p0);
        var pf1 = this.projectionFactor(seg.p1);
        if (pf0 >= 1.0 && pf1 >= 1.0) return null;
        if (pf0 <= 0.0 && pf1 <= 0.0) return null;
        var newp0 = this.project(seg.p0);
        if (pf0 < 0.0) newp0 = this.p0;
        if (pf0 > 1.0) newp0 = this.p1;
        var newp1 = this.project(seg.p1);
        if (pf1 < 0.0) newp1 = this.p0;
        if (pf1 > 1.0) newp1 = this.p1;
        return new LineSegment(newp0, newp1);
      }
    }
  }, {
    key: "normalize",
    value: function normalize() {
      if (this.p1.compareTo(this.p0) < 0) this.reverse();
    }
  }, {
    key: "angle",
    value: function angle() {
      return Math.atan2(this.p1.y - this.p0.y, this.p1.x - this.p0.x);
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate(i) {
      if (i === 0) return this.p0;
      return this.p1;
    }
  }, {
    key: "distancePerpendicular",
    value: function distancePerpendicular(p) {
      return Distance.pointToLinePerpendicular(p, this.p0, this.p1);
    }
  }, {
    key: "minY",
    value: function minY() {
      return Math.min(this.p0.y, this.p1.y);
    }
  }, {
    key: "midPoint",
    value: function midPoint() {
      return LineSegment.midPoint(this.p0, this.p1);
    }
  }, {
    key: "projectionFactor",
    value: function projectionFactor(p) {
      if (p.equals(this.p0)) return 0.0;
      if (p.equals(this.p1)) return 1.0;
      var dx = this.p1.x - this.p0.x;
      var dy = this.p1.y - this.p0.y;
      var len = dx * dx + dy * dy;
      if (len <= 0.0) return Double.NaN;
      var r = ((p.x - this.p0.x) * dx + (p.y - this.p0.y) * dy) / len;
      return r;
    }
  }, {
    key: "closestPoints",
    value: function closestPoints(line) {
      var intPt = this.intersection(line);
      if (intPt !== null) {
        return [intPt, intPt];
      }
      var closestPt = new Array(2).fill(null);
      var minDistance = Double.MAX_VALUE;
      var dist = null;
      var close00 = this.closestPoint(line.p0);
      minDistance = close00.distance(line.p0);
      closestPt[0] = close00;
      closestPt[1] = line.p0;
      var close01 = this.closestPoint(line.p1);
      dist = close01.distance(line.p1);
      if (dist < minDistance) {
        minDistance = dist;
        closestPt[0] = close01;
        closestPt[1] = line.p1;
      }
      var close10 = line.closestPoint(this.p0);
      dist = close10.distance(this.p0);
      if (dist < minDistance) {
        minDistance = dist;
        closestPt[0] = this.p0;
        closestPt[1] = close10;
      }
      var close11 = line.closestPoint(this.p1);
      dist = close11.distance(this.p1);
      if (dist < minDistance) {
        minDistance = dist;
        closestPt[0] = this.p1;
        closestPt[1] = close11;
      }
      return closestPt;
    }
  }, {
    key: "closestPoint",
    value: function closestPoint(p) {
      var factor = this.projectionFactor(p);
      if (factor > 0 && factor < 1) {
        return this.project(p);
      }
      var dist0 = this.p0.distance(p);
      var dist1 = this.p1.distance(p);
      if (dist0 < dist1) return this.p0;
      return this.p1;
    }
  }, {
    key: "maxX",
    value: function maxX() {
      return Math.max(this.p0.x, this.p1.x);
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this.p0.distance(this.p1);
    }
  }, {
    key: "compareTo",
    value: function compareTo(o) {
      var other = o;
      var comp0 = this.p0.compareTo(other.p0);
      if (comp0 !== 0) return comp0;
      return this.p1.compareTo(other.p1);
    }
  }, {
    key: "reverse",
    value: function reverse() {
      var temp = this.p0;
      this.p0 = this.p1;
      this.p1 = temp;
    }
  }, {
    key: "equalsTopo",
    value: function equalsTopo(other) {
      return this.p0.equals(other.p0) && this.p1.equals(other.p1) || this.p0.equals(other.p1) && this.p1.equals(other.p0);
    }
  }, {
    key: "lineIntersection",
    value: function lineIntersection(line) {
      try {
        var intPt = HCoordinate.intersection(this.p0, this.p1, line.p0, line.p1);
        return intPt;
      } catch (ex) {
        if (ex instanceof NotRepresentableException) {} else throw ex;
      } finally {}
      return null;
    }
  }, {
    key: "maxY",
    value: function maxY() {
      return Math.max(this.p0.y, this.p1.y);
    }
  }, {
    key: "pointAlongOffset",
    value: function pointAlongOffset(segmentLengthFraction, offsetDistance) {
      var segx = this.p0.x + segmentLengthFraction * (this.p1.x - this.p0.x);
      var segy = this.p0.y + segmentLengthFraction * (this.p1.y - this.p0.y);
      var dx = this.p1.x - this.p0.x;
      var dy = this.p1.y - this.p0.y;
      var len = Math.sqrt(dx * dx + dy * dy);
      var ux = 0.0;
      var uy = 0.0;
      if (offsetDistance !== 0.0) {
        if (len <= 0.0) throw new IllegalStateException('Cannot compute offset from zero-length line segment');
        ux = offsetDistance * dx / len;
        uy = offsetDistance * dy / len;
      }
      var offsetx = segx - uy;
      var offsety = segy + ux;
      var coord = new Coordinate(offsetx, offsety);
      return coord;
    }
  }, {
    key: "setCoordinates",
    value: function setCoordinates() {
      if (arguments.length === 1) {
        var ls = arguments[0];
        this.setCoordinates(ls.p0, ls.p1);
      } else if (arguments.length === 2) {
        var p0 = arguments[0];
        var p1 = arguments[1];
        this.p0.x = p0.x;
        this.p0.y = p0.y;
        this.p1.x = p1.x;
        this.p1.y = p1.y;
      }
    }
  }, {
    key: "segmentFraction",
    value: function segmentFraction(inputPt) {
      var segFrac = this.projectionFactor(inputPt);
      if (segFrac < 0.0) segFrac = 0.0;else if (segFrac > 1.0 || Double.isNaN(segFrac)) segFrac = 1.0;
      return segFrac;
    }
  }, {
    key: "toString",
    value: function toString() {
      return 'LINESTRING( ' + this.p0.x + ' ' + this.p0.y + ', ' + this.p1.x + ' ' + this.p1.y + ')';
    }
  }, {
    key: "isHorizontal",
    value: function isHorizontal() {
      return this.p0.y === this.p1.y;
    }
  }, {
    key: "distance",
    value: function distance() {
      if (arguments[0] instanceof LineSegment) {
        var ls = arguments[0];
        return Distance.segmentToSegment(this.p0, this.p1, ls.p0, ls.p1);
      } else if (arguments[0] instanceof Coordinate) {
        var p = arguments[0];
        return Distance.pointToSegment(p, this.p0, this.p1);
      }
    }
  }, {
    key: "pointAlong",
    value: function pointAlong(segmentLengthFraction) {
      var coord = new Coordinate();
      coord.x = this.p0.x + segmentLengthFraction * (this.p1.x - this.p0.x);
      coord.y = this.p0.y + segmentLengthFraction * (this.p1.y - this.p0.y);
      return coord;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      var bits0 = java.lang.Double.doubleToLongBits(this.p0.x);
      bits0 ^= java.lang.Double.doubleToLongBits(this.p0.y) * 31;
      var hash0 = Math.trunc(bits0) ^ Math.trunc(bits0 >> 32);
      var bits1 = java.lang.Double.doubleToLongBits(this.p1.x);
      bits1 ^= java.lang.Double.doubleToLongBits(this.p1.y) * 31;
      var hash1 = Math.trunc(bits1) ^ Math.trunc(bits1 >> 32);
      return hash0 ^ hash1;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return LineSegment;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparable, Serializable];
    }
  }], [{
    key: "midPoint",
    value: function midPoint(p0, p1) {
      return new Coordinate((p0.x + p1.x) / 2, (p0.y + p1.y) / 2);
    }
  }]);
}();
export { LineSegment as default };
LineSegment.constructor_ = function () {
  this.p0 = null;
  this.p1 = null;
  if (arguments.length === 0) {
    LineSegment.constructor_.call(this, new Coordinate(), new Coordinate());
  } else if (arguments.length === 1) {
    var ls = arguments[0];
    LineSegment.constructor_.call(this, ls.p0, ls.p1);
  } else if (arguments.length === 2) {
    var p0 = arguments[0];
    var p1 = arguments[1];
    this.p0 = p0;
    this.p1 = p1;
  } else if (arguments.length === 4) {
    var x0 = arguments[0];
    var y0 = arguments[1];
    var x1 = arguments[2];
    var y1 = arguments[3];
    LineSegment.constructor_.call(this, new Coordinate(x0, y0), new Coordinate(x1, y1));
  }
};
LineSegment.serialVersionUID = 3252005833466256227;